function updateTimezone(element) {
  const timeZone = element.dataset.timezone;
  const locale = element.dataset.locale ?? 'fr-FR';
  if (!timeZone) return;

  const utc = new Intl.DateTimeFormat(locale, {
    timeZoneName: 'shortOffset',
    timeZone,
  })
    .formatToParts()
    .find((el) => el.type === 'timeZoneName').value;

  const time = new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone,
  });

  const timeFormat = time.format();
  const dayPeriod = time.formatToParts().find((el) => el.type === 'dayPeriod')?.value;

  element.querySelector('.timezone-utc').textContent = utc;
  element.querySelector('.timezone-time').textContent = timeFormat.replace(/\s(am|pm)/gi, '');
  if (dayPeriod) {
    const dayPeriodElement = element.querySelector('.timezone-day-period');

    if (!dayPeriodElement) {
      const elementBefore = element.querySelector('.timezone-time');
      const newElement = document.createElement('sup');
      newElement.classList.add('timezone-day-period');
      newElement.textContent = dayPeriod;
      elementBefore.appendChild(newElement);
    } else dayPeriodElement.textContent = dayPeriod;
  }
}

function setupTimezoneTimer() {
  const timezones = document.querySelectorAll('[data-timezone]');

  document.addEventListener('DOMContentLoaded', () => {
    timezones.forEach(updateTimezone);

    setInterval(() => {
      timezones.forEach(updateTimezone);
    }, 1000);
  });
}

function setupListenersMenu() {
  const open = document.getElementById('header-menu-open');
  const close = document.getElementById('header-menu-close');
  const menu = document.getElementById('header-menu');

  if (open) {
    open.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      menu.classList.add('open');
    });
  }

  if (close) {
    close.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      menu.classList.remove('open');
    });
  }

  document.addEventListener('click', (e) => {
    if (menu.classList.contains('open') && !menu.contains(e.target)) {
      menu.classList.remove('open');
    }
  });
}

var interval;

function makeTimezoneSlide() {
  const container = document.querySelector('.timezone-container');
  const elements = container.querySelectorAll('.timezone');
  if (elements.length <= 1) return;

  let index = 0;

  interval = setInterval(() => {
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.transform = `translateY(-${36 * index}px)`;
    }

    index++;

    if (index >= elements.length) {
      index = 0;
    }
  }, 2500);
}

function setupTimezone() {
  if (window.innerWidth < 840 && !interval) {
    makeTimezoneSlide();
  } else if (window.innerWidth >= 840 && interval) {
    clearInterval(interval);
    interval = null;
    const elements = document.querySelectorAll('.timezone');
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.transform = null;
    }
  }
}

window.addEventListener('resize', setupTimezone);
setupTimezone();

setupListenersMenu();
setupTimezoneTimer();
